import React, { useState } from 'react';
import apiClient from '../api/client';
import { Button, Box, Paper } from '@mui/material';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";
import { setToken } from '../auth';

const Login = () => {
    const navigate = useNavigate();
    const [isFailedLogin, setFailedLogin] = useState(false);
    
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);

    async function handleLoginSubmit (event) {
        event.preventDefault();

        const uname = username.trim();

        if(!uname || !password) {
            setFailedLogin(true);
            return;
        }

        setSubmitting(true);
        setFailedLogin(false);

        try {
            const res = await apiClient.post('/validateUser', { username: uname, password });

            if(res.status === 200 && res.data?.token) {
                setToken(res.data.token);
                navigate("/dashboard", { replace: true });
                return;
            }
            setFailedLogin(true);
        } catch (err) {
            setFailedLogin(true);
            console.error('Login error:', err);
        }
        setSubmitting(false);
    }

    return(
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                p: 2,
            }}
        >
            <Paper
                sx={{
                    width: '100%',
                    maxWidth: 420,
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    borderRadius: 3,
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <Logo width={150} />
                </Box>


    
                {isFailedLogin && (
                    <Alert severity="error" sx={{ width: '100%', mb: 2.5, borderRadius: 2 }}>
                        Invalid username or password
                    </Alert>
                )}

                <Box component="form" onSubmit={handleLoginSubmit} noValidate sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        id="username"
                        name="username"
                        label="Username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                        variant="outlined"
                        fullWidth
                        size="medium"
                    />
                    <TextField
                        id="password"
                        name="password"
                        label="Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        size="medium"
                        autoComplete="current-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                    />
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        variant="outlined"
                        fullWidth
                        size="large"
                        sx={{ mt: 1, py: 1.25 }}
                    >
                        {isSubmitting ? 'Signing in…' : 'Sign In'}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default Login;